//============================================================================
// Redux
//============================================================================
export enum CustomersActions {
  StoreInitialState,

  // Customer
  CustomerUpdate,

  // Contact
  ContactCreate,
  ContactUpdate,
  ContactDestroy,

  // Field
  FieldCreate,
  FieldUpdate,
  FieldDestroy,
}

//============================================================================
// Add Component
//============================================================================
// export interface IAddProps {
//     code: string,
//     itemNumber: string;
//     inStock: number;
//     description: string;

//     setInventoryRequest: (payload?: any) => void;
// }

//============================================================================
// Checkout Component
//============================================================================
// export interface ICheckoutProps {
//     code: string;
//     url: string;
//     checkout_url: string;
//     items: any;// todo

//     setInventoryRequest: (payload?: any) => void;
//     unsetInventoryRequest: (payload?: any) => void;
//     clearInventoryRequest: (payload?: any) => void;
// }
